import { Button } from 'components/ui/button';
import { treezpayAppUrl, treezLoginPageUrl } from 'utils/urlGenerator';
import { ENV } from 'utils/config';
import { oneAppUrl } from 'utils/urlGenerator';

const LoginSSO = (): JSX.Element => {
  const ssoLogin = async () => {
    const env = ENV || 'production';
    const url = `${treezLoginPageUrl(
      env
    )}/?application=MSO&callback=${treezpayAppUrl(env)}/&authorize=true`;
    window.open(url, '_top');
  };

  return (
    <div>
      <div className="mb-4 md:mb-6 text-sm text-gray-900">
        Use your SellTreez credentials to sign in to TreezPay
      </div>

      <Button
        data-testid="ssoLoginBtn"
        type="submit"
        variant="treez-green"
        size="full"
        rounded="base"
        className="mb-4 md:mb-6"
        onClick={() => {
          ssoLogin();
        }}
        iconEnd="arrow-right"
      >
        Continue with TreezPay
      </Button>

      <div className="text-sm text-gray-900">
        Don't have an account?{' '}
        <a
          rel="noreferrer"
          target="_blank"
          href={oneAppUrl(ENV || 'production')}
          className="font-medium text-dark-green-link underline hover:no-underline"
        >
          Sign up
        </a>
      </div>
    </div>
  );
};

export default LoginSSO;
